export const types = {
  FETCH_MORE_LIKE_THIS: '@MORE_LIKE_THIS/FETCH_MORE_LIKE_THIS',
  FETCH_MORE_LIKE_THIS_ERROR: '@MORE_LIKE_THIS/FETCH_MORE_LIKE_THIS_ERROR',
};

export const fetchMoreLikeThis = (params, reduxDocumentsKey) => ({
  type: types.FETCH_MORE_LIKE_THIS,
  params,
  reduxDocumentsKey,
});

export const fetchMoreLikeThisError = (response) => ({
  type: types.FETCH_MORE_LIKE_THIS_ERROR,
  response,
});
